import React from "react";
import AsyncSelect from "../AsyncSelect";

const TestSelect = props => {
  const loadPath = 'tests';

  const formatOptions = (options) => (
    (options || []).map(option =>
      ({label: option.name, value: {id: option.id, name: option.name}}))
  );

  const getOptionValue = (option) => option.value.id;

  return (
    <AsyncSelect {...{ ...props, getOptionValue, formatOptions, loadPath }} />
  );
};

export default TestSelect;
